<template>
    <div id="app" style="min-width: 1300px">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }
    .edui-default {
        z-index: 11000 !important;
    }
    .edui-box {
        line-height: normal;
    }
    .flex {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }

    .flex-alc {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .justify-between {
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }

    .flex-item {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        min-width: 0;
    }

    .f14 {
        font-size: 14px;
    }

    .mgb-20 {
        margin-bottom: 20px;
    }

    .mgt-20 {
        margin-top: 20px;
    }

    .mgb-30 {
        margin-bottom: 30px;
    }

    .mgb-10 {
        margin-bottom: 10px;
    }

    .mgt-10 {
        margin-top: 10px;
    }

    .f12 {
        font-size: 12px;
    }

    .mgt-30 {
        margin-top: 30px;
    }

    .filter-container, .table-container {
        margin: 20px;
    }

    .pagination-container {
        display: inline-block;
        float: right;
        margin-top: 20px;
        margin-right: 20px;
    }

    .pagination-container:after {
        display: block;
        content: ' ';
        clear: both;
    }

    .operate-container {
        margin: 0 20px;
    }

    .margin-botton-20px {
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue